import type { ApiClient } from "../../api";
import {
  getApiV1UserGuide,
  postApiV1UserGuideRefresh,
} from "../../api/generated";

/**
 * Инструкция сотрудника: копия страницы Confluence, которую держит ядро.
 *
 * Браузер к Confluence не обращается: читается готовая копия из ERP, а
 * «Проверить обновления» лишь просит ядро сверить версию страницы.
 */
export class UserGuideApi {
  constructor(private readonly client: ApiClient) {}

  get() {
    return getApiV1UserGuide(this.client);
  }

  /** Просит ядро проверить страницу в Confluence; проверка идёт в фоне. */
  refresh() {
    return postApiV1UserGuideRefresh(this.client);
  }
}
